module.exports = __webpack_public_path__ + "img/no_rvm.2a9612bf.png";